import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoadingController, NavController } from '@ionic/angular';
import { ClientService } from 'src/app/services/client.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'all-transactions',
  templateUrl: './all-transactions.component.html',
  styleUrls: ['./all-transactions.component.scss'],
})
export class AllTransactionsComponent implements OnInit, OnDestroy {
  orders: any[];
  document = '';
  interval: any;
  page = 0;

  constructor(private clientService: ClientService, private navCtrl: NavController, private loadingCtrl: LoadingController) { }

  async ngOnInit() {
    const loading = await this.loadingCtrl.create({ message: 'Carregando...' });
    loading.present();

    this.getTransactions();
    this.document = Security.getDocument();

    this.startGetByMinute();

    loading.dismiss();
  }

  async getTransactions() {
    this.clientService.getAllTransactions(this.page).subscribe(result => {
      if (result.success) {
        this.orders = result.data.orders;
      }
    });
  }
  loadData(event) {
    this.page++;
    this.clientService.getAllTransactions(this.page).subscribe(result => {
      if (result.success) {

        if (result.data.numberOfPage === this.page) {
          event.target.disabled = true;
          event.target.complete();
          return;
        }
        const newData = result.data.orders;
        this.orders.push(...newData);
      }
      event.target.complete();
    });
  }

  goToPage(page: any) {
    const uri = '/master/wallet/extract/details/'; 
    this.navCtrl.navigateForward( uri + page);
  }

  async startGetByMinute() {
    this.interval = setInterval(async () => {
      await this.getTransactions();
    }, 60000);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

}
